const facebookShareEvent = () => {
	/* eslint-disable no-undef */
	FB.ui({
	/* eslint-enable no-undef */
		method: 'share',
		href: window.location.href,
	}, (response) => console.log(response));
};

/**
 * bind click listener to share a Facebook post
 */
const setupFacebookShareLink = (element) => {
	element.addEventListener('click', () => {
		if (process.env.DEV) {
			console.log('Facebook SDK doesn\'t work at localhost.');
			return;
		}

		facebookShareEvent();
	});
};

export default setupFacebookShareLink;



// WEBPACK FOOTER //
// ./src/js/common/setupFacebookShareLink.js